import angular from "angular";
import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";
import { EnsenyamentsDataService } from "../services/ensenyaments.service";
import { IApiSubetapa } from "../services/api.model";
import { SERVEIS_EDUCATIUS } from ".";

class Component {
  public serveisEducatius: IApiSubetapa[] = SERVEIS_EDUCATIUS;
  public isOpen = false;

  constructor(
    private $scope,
    private EnsenyamentsData: EnsenyamentsDataService,
  ) { }

  $onInit() {
    this.setupListeners();
    angular.extend(this.EnsenyamentsData.serveisEducatius, this.serveisEducatius);
  }

  toggle() {
    this.isOpen = !this.isOpen;
  };

  private setupListeners() {
    this.$scope.$on('clear', () => {
      angular.extend(this.serveisEducatius, this.EnsenyamentsData.serveisEducatius);
    }, true);

    this.$scope.$on('searchInit', () => {
      this.isOpen = false;
    });
  }
}

const component: ng.IComponentOptions = {
  bindings: {},
  templateUrl: './components/search-edu.component.html',
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.SEARCH_EDU, component);